import { Types } from './actions';

export const INITIAL_STATE = {
  creatingPassword: null,
};

type TypeAction = {
  type: string;
  payload: boolean | null;
};

export default function cardPassword(
  state = INITIAL_STATE,
  action: TypeAction,
) {
  switch (action.type) {
    case Types.CREATING_PASSWORD: {
      return {
        creatingPassword: action.payload,
      };
    }
    default:
      return state;
  }
}
